import OpinionScale from './OpinionScale';
import RatingInput from './RatingInput';
import SliderInput from './SliderInput';

/** Scale blocks by element key, for registering with the form library. */
export const SCALE_BLOCK_COMPONENTS: Record<string, React.ComponentType<any>> = {
  RatingInput,
  OpinionScale,
  SliderInput,
};
